import React, { useState, useEffect } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import axios from 'axios';
import moment from 'moment';
import { toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert';
import queryString from 'query-string';

const ReserveFail = (props) => {
  const { history, location, apiUrl, imgUrl } = props; //   console.log(history, location);
  const query = queryString.parse(location.search);
  const message = query.message;
  const orderCode = query.orderCode;
  console.log(orderCode);
  const [infoData, setInfoData] = useState([]);

  const _getData = async () => {
    const result = await axios.post(apiUrl + '/exhibitionFail', {
      orderCode: orderCode,
    });
    console.log(result);
    const intReturn = result.data[0].intReturn;
    const listData = result.data[0].listData;
    if (intReturn === 0) {
      setInfoData(listData);
    } else {
      history.push('/reserve');
    }
  };
  const _reserve = () => {
    history.push('/reserve');
  };
  const CommaFormatted = (str) => {
    //console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = '';
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = ',' + (parseInt(str) % 1000) + '00' + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = ',' + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ',0' + (parseInt(str) % 1000) + Money;
          else Money = ',00' + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  useEffect(() => {
    if (orderCode === '' || orderCode === undefined || orderCode === null) {
    } else {
      _getData();
    }
  }, [orderCode]);
  if (infoData.length <= 0) {
    return <div></div>;
  }
  return (
    <>
      <div id="wrap">
        <a href="#" className="prev"></a>
        {/* <!-- 컨텐츠영역 --> */}
        <section className="container5 tiket2">
          {/* <!-- 왼쪽 컨텐츠 --> */}
          <div className="bx bx_left">
            <h1>
              <img src={imgUrl + '/img/mediaArt/logo.svg'} alt="" />
            </h1>
            <div className="comfirm">
              <div className="icon">
                <img src={imgUrl + '/img/mediaArt/icon_comfirm.gif'} alt="" />
              </div>
              <div className="txt">
                결제 실패! 잠시 후 다시 시도해 주세요
                <br />
                사유: {message}
              </div>
            </div>
            <div className="section sec_item">
              <h2>선택 내역</h2>
              <div className="item">
                <div className="thumb">
                  <img src={imgUrl + '/img/mediaArt/img_wrap.jpg'} alt="" />
                </div>
                <ul>
                  <li>
                    <span className="tit">작품명</span>
                    <span className="txt">{infoData[0].exhibitionName}</span>
                  </li>
                  <li>
                    <span className="tit">장소</span>
                    <span className="txt">
                      {infoData[0].exhibitionLocationName}
                    </span>
                  </li>
                  <li>
                    <span className="tit">날짜</span>
                    <span className="txt">
                      {moment(
                        infoData[0].rdate.toString().substring(0, 4) +
                          '-' +
                          infoData[0].rdate.toString().substring(4, 6) +
                          '-' +
                          infoData[0].rdate.toString().substring(6, 8)
                      ).format('YYYY.MM.DD(dd)')}
                    </span>
                  </li>
                  <li>
                    <span className="tit">시간</span>
                    <span className="txt">{infoData[0].rtimeName}</span>
                  </li>
                  <li>
                    <span className="tit">예매수</span>
                    <span className="txt">{infoData[0].rcount}매</span>
                  </li>
                  <li>
                    <span className="tit">결제금액</span>
                    <span className="txt">
                      {' '}
                      {CommaFormatted(infoData[0].price)}원
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="section sec_paycont">
              <h2>결제 내역</h2>
              <ul>
                <li>
                  <span className="tit">결제수단</span>
                  <span className="txt">
                    {infoData[0].payType} |{' '}
                    {infoData[0].payType === '간편결제'
                      ? infoData[0].payName
                      : infoData[0].codeName}
                  </span>
                </li>
                <li>
                  <span className="tit">결제일</span>
                  <span className="txt">
                    {' '}
                    {moment(infoData[0].orderDate).format('YYYY.MM.DD hh:mm')}
                  </span>
                </li>
              </ul>
            </div>
          </div>
          {/* <!-- 오른쪽 컨텐츠 --> */}
          <div className="bx bx_right">
            <div className="section_line">
              <div className="comfirm">
                <div className="icon">
                  <img src={imgUrl + '/img/mediaArt/error.gif'} alt="" />
                </div>
                <div className="txt">
                  결제 실패! 잠시 후 다시 시도해 주세요
                  <br />
                  사유: {message}
                </div>
              </div>
            </div>
            {/* <div className="section section_line">
              <div className="sec_approve">
                <h2>승인번호</h2>
                <div className="approve_input">
                  <input type="text" className="input" />
                  <a href="#">발권승인</a>
                </div>
              </div>
            </div> */}
            <div className="section section_line sec_item">
              <h2>선택 내역</h2>
              <div className="item">
                <div className="thumb">
                  <img src={infoData[0].img} alt="" />
                </div>
                <ul>
                  <li>
                    <span className="tit">작품명</span>
                    <span className="txt">{infoData[0].exhibitionName}</span>
                  </li>
                  <li>
                    <span className="tit">장소</span>
                    <span className="txt">
                      {infoData[0].exhibitionLocationName}
                    </span>
                  </li>
                  <li>
                    <span className="tit">날짜</span>
                    <span className="txt">
                      {moment(
                        infoData[0].rdate.toString().substring(0, 4) +
                          '-' +
                          infoData[0].rdate.toString().substring(4, 6) +
                          '-' +
                          infoData[0].rdate.toString().substring(6, 8)
                      ).format('YYYY.MM.DD(dd)')}
                    </span>
                  </li>
                  <li>
                    <span className="tit">시간</span>
                    <span className="txt">{infoData[0].rtimeName}</span>
                  </li>
                  <li>
                    <span className="tit">예매수</span>
                    <span className="txt">{infoData[0].rcount}매</span>
                  </li>
                  <li>
                    <span className="tit">결제금액</span>
                    <span className="txt">
                      {CommaFormatted(infoData[0].price)}원
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="section section_line sec_paycont">
              <h2>결제 내역</h2>
              <ul>
                <li>
                  <span className="tit">결제수단</span>
                  <span className="txt">
                    {' '}
                    {infoData[0].payType} |{' '}
                    {infoData[0].payType === '간편결제'
                      ? infoData[0].payName
                      : infoData[0].codeName}
                  </span>
                </li>
                <li>
                  <span className="tit">결제일</span>
                  <span className="txt">
                    {moment(infoData[0].orderDate).format('YYYY.MM.DD hh:mm')}
                  </span>
                </li>
              </ul>
            </div>
            <div className="section">
              <div className="btn_area">
                <a href="#" style={{ width: '100%' }} onClick={_reserve}>
                  다시 예매하기
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default shopContext(withRouter(ReserveFail));
